import { COLORS } from "./siteInfo/SiteStyle";

const appStyle = {
  App: {
    backgroundColor: COLORS.backColor,
    overflow: "hidden",
  },
};
export default appStyle;
